import React, { useState, useEffect } from 'react';
import { formatCurrency } from '../utils/formatters';
import { CLIENT_LABEL_MAPPING } from '../utils/clientLabels';
import './OrderSelectorModal.css';

const OrderSelectorModal = ({ onClose, onSelect, title = "Selecionar Cliente e Pedido" }) => {
    const [clients, setClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClient, setSelectedClient] = useState(null);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async (query = '') => {
        setLoading(true);
        try {
            const url = query ? `/api/clientes?Nome=${encodeURIComponent(query)}` : '/api/clientes';
            const res = await fetch(url, { credentials: 'include' });
            if (res.ok) setClients(await res.json());
        } catch (err) {
            console.error('Erro ao buscar clientes:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        fetchClients(searchTerm);
    };

    const fetchOrders = async (clientId) => {
        setLoading(true);
        try {
            const res = await fetch(`/api/clientes/${clientId}/pedidos`, { credentials: 'include' });
            if (res.ok) setOrders(await res.json());
        } catch (err) {
            console.error('Erro ao buscar pedidos:', err);
        } finally {
            setLoading(false);
        }
    };

    const selectClient = (client) => {
        setSelectedClient(client);
        fetchOrders(client.ID);
    };


    return (
        <div className="modal-overlay">
            <div className="modal-content order-selector-modal">
                <div className="win-title">{title}</div>

                <div className="win-body">
                    {!selectedClient ? (
                        <>
                            <div className="search-box">
                                <input
                                    type="text"
                                    placeholder="Buscar cliente por nome..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                                />
                                <button className="btn-classic" onClick={handleSearch}>Buscar</button>
                            </div>

                            <div className="selector-list">
                                {loading ? <p>Carregando clientes...</p> :
                                    clients.length > 0 ? clients.map(c => (
                                        <div key={c.ID} className="selector-item" onClick={() => selectClient(c)}>
                                            <strong>
                                                #{c.ID} - {c.Nome || `${CLIENT_LABEL_MAPPING['SobrenomeContato']}: ${c.SobrenomeContato}, ${CLIENT_LABEL_MAPPING['PrimeiroNomeContato']}: ${c.PrimeiroNomeContato}`}
                                            </strong>
                                            <span>{c.Cidade} - {c.EstadoProvincia}</span>
                                        </div>
                                    )) : <p>Nenhum cliente encontrado.</p>}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="client-header">
                                <button className="btn-classic btn-back" onClick={() => setSelectedClient(null)}>← Voltar</button>
                                <h3>{title.includes('Orçamento') ? 'Orçamentos' : 'Pedidos'} de: {selectedClient.Nome || selectedClient.PrimeiroNomeContato}</h3>
                            </div>

                            <div className="selector-list">
                                {loading ? <p>Carregando pedidos...</p> :
                                    orders.length > 0 ? orders.map(o => (
                                        <div key={o.ID} className="selector-item" onClick={() => onSelect(o, selectedClient)}>
                                            <div className="order-main-info">
                                                <strong>{title.includes('Orçamento') ? 'Orçamento' : 'Pedido'} #{o.ID}</strong>
                                                <span>{new Date(o.DataPedido).toLocaleDateString('pt-BR')}</span>
                                            </div>
                                            <div className="order-sub-info">
                                                <span>{o.OBS || '(Sem descrição)'}</span>
                                                <span className="order-value">{formatCurrency(o.Frete)}</span>
                                            </div>
                                        </div>
                                    )) : <p>Este cliente não possui {title.includes('Orçamento') ? 'orçamentos' : 'pedidos'}.</p>}
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-actions">
                    <button className="btn-classic danger" onClick={onClose}>Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default OrderSelectorModal;
